<template>
  <div v-viewer="{ toolbar: false }">
    <img
      v-if="attachment.type === 'image'"
      class="max-h-72"
      :src="attachment.downloadURL"
    />
    <img
      v-if="attachment.type === 'sticker'"
      class="max-h-36"
      :src="attachment.downloadURL"
    />
    <audio
      v-if="attachment.type === 'audio'"
      class="max-h-72"
      :src="attachment.downloadURL"
      controls
    />
    <video
      v-if="attachment.type === 'video'"
      class="max-h-72"
      :src="attachment.downloadURL"
      controls
    />
    <div v-if="attachment.type === 'file'">
      <div class="flex">
        <div class="flex">
          <!-- Heroicon name: solid/paper-clip -->
          <svg
            class="flex-shrink-0 h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="ml-2 flex-1 ">
            {{ attachment.name }}
          </span>
        </div>
        <div class="ml-4 flex-shrink-0">
          <a
            target="_blank"
            :href="attachment.downloadURL"
            class="font-medium text-blue-600 hover:text-blue-500"
          >
            Download
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import { directive as viewer } from "v-viewer";

export default {
  name: "AttachmentItem",
  directives: {
    viewer: viewer({
      debug: true
    })
  },
  props: {
    attachment: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped></style>
